import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import { useSport } from '../../../context/SportContext';
import { getAllSportList } from '../../../services/commonApiService/CommonApiService';
const SportFilter = ({ value, onChange }) => {
    const [sportsList, setSportsList] = useState([]);
    const { selectedSportId, setSelectedSportId } = useSport();

    const isControlled = value !== undefined;
    const currentValue = isControlled ? value : selectedSportId;

    useEffect(() => {
        const fetchSportsList = async () => {
            try {
                const response = await getAllSportList();
                setSportsList(response?.data?.data || []);
            } catch (error) {
                console.error('Error fetching sports list:', error);
            }
        };

        fetchSportsList();
    }, []);

    const handleChange = (e) => {
        const selectedId = e.target.value;
        const selectedSport = sportsList.find(s => String(s.sport_id) === String(selectedId));
        const sportName = selectedSport ? selectedSport.sport_name : "";

        if (isControlled) {
            if (onChange) onChange(selectedId, sportName);
        } else {
            setSelectedSportId(selectedId);
        }
    };
    return (
        <>
            <div>
                <Form.Select
                    value={currentValue}
                    onChange={handleChange}
                    className="me-2"
                    style={{ width: '200px', padding: '11px' }}
                >
                    <option value="0">All Sports</option>
                    {sportsList.map((item) => (
                        <option key={item.id} value={item?.sport_id}>
                            {item.sport_name}
                        </option>
                    ))}
                </Form.Select>
            </div>
        </>
    )
}

export default SportFilter